import { FC } from 'react';
import { dateTimeToCustomFormat } from '../../utils';
import personalizeImg from '../../../assets/image/personalize.png';
import Tag, { TagStyle } from '../Tag/Tag';
import { Theme } from '../types/enums';
import { useBreakpoint } from '../Breakpoint/BreakpointProvider';
import { DetailCardCoachPropTypes } from './types/propTypes';
import styles from './index.module.scss';

const DetailCardCoach: FC<DetailCardCoachPropTypes> = (props: DetailCardCoachPropTypes) => {
  const {
    name,
    coachId,
    endDate,
    // enrollmentDate,
    // ALPCount,
    achievedCount,
    completedCount,
    totalPersonalSponsor,
    handleRedirect,
    profileImageUrl,
  } = props;

  const viewPortType = useBreakpoint();
  const isDesktopView = ['xs', 'sm'].indexOf(viewPortType) === -1;

  return (
    <section className={styles['card-container']} onClick={handleRedirect ? handleRedirect : undefined}>
      {/* profile image and details section */}
      <div className={styles['card-details-container-info']}>
        {/* profile image  */}
        <div className={styles['card-details-container-info-image-container']}>
          <img
            src={profileImageUrl ? profileImageUrl : personalizeImg}
            className={styles['card-details-container-info-image-container-img']}
            width={isDesktopView ? 100 : 60}
            height={isDesktopView ? 100 : 60}
            alt="personalize"
          />
        </div>
        {/* profile details */}
        <div className={styles['profile-details-container-info']}>
          <div className={styles['profile-name']}>
            <div className={styles['profile-name-label']}>{name}</div>
            {!isDesktopView && (
              <div className={styles['tag-container-mobile']}>
                <Tag
                  text={`END DATE: ${dateTimeToCustomFormat(endDate, 'MMM yyyy')}`}
                  theme={Theme.ERROR}
                  style={TagStyle.OUTLINE}
                />
              </div>
            )}
          </div>
          <div className={styles['profile-name-label-normal']}>Coach ID: {coachId}</div>
          {/* <div className={styles['profile-name-label-normal']}>
            Declaration Date: {dateTimeToCustomFormat(enrollmentDate, 'MMM yyyy')}
          </div> */}
        </div>
      </div>
      <div className={styles['card-details-container']}>
        <div className={styles['card-info-box']}>
          <div className={styles['card-info-label']}>Completed Journey</div>
          <div className={styles['card-info-value']}>{completedCount}</div>
        </div>
        <div className={styles['card-info-box']}>
          <div className={styles['card-info-label']}>Achieved Individual Criteria</div>
          <div className={styles['card-info-value']}>{achievedCount}</div>
        </div>
        <div className={styles['card-info-box']}>
          <div className={styles['card-info-label']}>New Personal Sponsored ABO/APC</div>
          <div className={styles['card-info-value']}>{totalPersonalSponsor}</div>
        </div>
      {/* <div className={styles['card-info-box']}>
          <div className={styles['card-info-label']}>Subscribe to SOP
           <span className={styles['card-info-label-note']}>
              *Not a winning criteria
           </span>
          </div>
          <div className={styles['card-info-value']}>{ALPCount}</div>
        </div> */}
      </div>

      {isDesktopView && (
        <div className={styles['card-tag']}>
          <Tag
            text={`END DATE: ${dateTimeToCustomFormat(endDate, 'MMM yyyy')}`}
            theme={Theme.ERROR}
            style={TagStyle.OUTLINE}
          />
        </div>
      )}
    </section>
  );
};

export default DetailCardCoach;
export type { DetailCardCoachPropTypes };
